import { PrinterStatusData } from 'data/types/printerStatus';

export const normalizePrinterStatus = (data: PrinterStatusData) => ({
  facilityId: data.facilityId,
  organizationId: data.organizationId,
  isActive: data.isActive,
  ttl: data.ttl,
});

export type PrinterStatus = ReturnType<typeof normalizePrinterStatus>;
